<template>
  <div class="root">
  <pc-quick-start></pc-quick-start>
  </div>
</template>

<script>
  import PcQuickStart from '../../views/documentation/quick-start.component'

  export default {
    name: 'quick-start.page',
    components: {
      PcQuickStart,
    }
  }
</script>

<style scoped>

</style>